import '@/css/main.css';
import 'virtual:svg-icons-register';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import 'lazysizes';

declare global {
    interface Window {
        RiseFR: any;
    }
}

document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});

window.RiseFR = {
    defaults(): RiseAPP {
        return {
            isReady: false,
            isLoading: false,
            isSearching: false,
            showMenu: false,
            showFilter: false,
            showLanguages: false,
            showSecondarySub: false,
            openSubMenu: 0,
            quoteSectionHeight: 0,
            quoteNum: 0,
            quoteIndex: -1,
            query: '',
            searchableElements: [],
            activeFilters: {
                tags: [],
                type: []
            },
            entries: [],
            baseUrl: '',
            viewType: localStorage.getItem('viewType') || 'grid',
            init: async function () {
                this.showMenu = window.innerWidth > 1240;
                window.addEventListener('resize', () => {
                    this.showMenu = window.innerWidth > 1240;
                });
            },
            async checkQuoteHeights() {
                await this.sleep(500);
                this.quoteIndex = 0;
                this.quoteNum = 0;
                document.querySelectorAll('.js--quote').forEach(elm => {
                    this.quoteSectionHeight = Math.max(
                        this.quoteSectionHeight,
                        elm.getBoundingClientRect().height
                    );
                    this.quoteNum++;
                });
                setInterval(() => {
                    this.loopQuotes();
                }, 10000);
            },
            initEntries(url: string) {
                this.baseUrl = url;
                this.fetchEntries();
            },
            fetchEntries() {
                if (this.baseUrl === '') return;
                const tmp = setTimeout(() => {
                    this.isSearching = true;
                }, 100);
                let url = this.baseUrl + '&q=' + this.query;
                if (this.activeFilters.tags.length) {
                    url += '&tags=' + this.activeFilters.tags.join(',');
                }
                if (this.activeFilters.type.length) {
                    url += '&type=' + this.activeFilters.type.join(',');
                }

                fetch(url)
                    .then(res => res.json())
                    .then(res => {
                        this.entries = [];
                        setTimeout(() => {
                            clearTimeout(tmp);
                            this.isSearching = false;
                            this.entries = res.entries;
                        }, 1);
                    });
            },
            loopQuotes() {
                this.quoteIndex++;
                if (this.quoteIndex >= this.quoteNum) {
                    this.quoteIndex = 0;
                }
            },
            inlineSearch() {
                this.searchableElements.forEach(elm => {
                    if (
                        elm
                            .getAttribute('data-searchable')
                            ?.toLowerCase()
                            .includes(this.query.toLowerCase())
                    ) {
                        elm.classList.remove('hidden', 'md:hidden');
                    } else {
                        elm.classList.add('hidden', 'md:hidden');
                    }
                });
            },
            toggleFilter(type: 'tags' | 'type', id: number | null) {
                if (id === null) {
                    this.activeFilters[type] = [];
                } else {
                    if (this.activeFilters[type].includes(id)) {
                        this.activeFilters[type].splice(this.activeFilters[type].indexOf(id), 1);
                    } else {
                        this.activeFilters[type].push(id);
                    }
                }
                this.fetchEntries();
            },
            setViewType(t: string) {
                this.viewType = t;
                localStorage.setItem('viewType', t);
            },
            checkAside() {
                const aside = document.querySelector('.js--kontaktpersoner');
                if (!aside) return;
                const div = aside?.nextElementSibling as HTMLDivElement;
                if (!div) return;
                div.style.minHeight = aside.getBoundingClientRect().height + 'px';
            },
            sleep(ms: number) {
                return new Promise(resolve => setTimeout(resolve, ms));
            }
        };
    }
};

Alpine.plugin(collapse);
Alpine.start();

interface RiseAPP {
    isReady: boolean;
    isLoading: boolean;
    isSearching: boolean;
    showMenu: boolean;
    showFilter: boolean;
    showLanguages: boolean;
    showSecondarySub: boolean;
    openSubMenu: number;
    quoteSectionHeight: number;
    quoteNum: number;
    quoteIndex: number;
    query: string;
    searchableElements: HTMLElement[];
    activeFilters: {
        tags: number[];
        type: number[];
    };
    entries: any[];
    baseUrl: string;
    viewType: string;
    init(): void;
    initEntries(url: string): void;
    fetchEntries(): void;
    checkQuoteHeights(): void;
    loopQuotes(): void;
    inlineSearch(): void;
    toggleFilter(type: 'tags' | 'type', id: number | null): void;
    setViewType(t: string): void;
    checkAside(): void;
    sleep(ms: number): void;
}
